module.exports = __webpack_public_path__ + "static/headshot-mike-myers.298c2287.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-mike-myers.jpg
// module id = 131
// module chunks = 35783957827783 152909308826437